import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const search_product_by_id = (id) => {
  return api.post(`${ApiEndpointConstants.SEARCHPRODUCTBYID}`, {
    id,
  });
};
